<template>
  <div v-if="display_open_date_check(date)">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      date: '2024-04-01',
    };
  },
  methods: {
    display_open_date_check(date) {
      const today = new Date();
      const targetDate = new Date(date);
      today.setHours(0, 0, 0, 0);
      targetDate.setHours(0, 0, 0, 0);
      return targetDate <= today;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/display_time.vue